import React from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Button,message, Descriptions, Divider, Space, Empty} from 'antd';
import { dbFields } from '../../model/device/column';
import { RefreshPing, eraseCID, factoryReset, getDeviceByImei ,lock,stopFactoryReset,unLock} from '../../model/device/requests';
import storage from "../../utils/storage";
import { configs } from "../../config/config";
import { route } from "../../routes/routes";
import { getDeviceFinance } from "../../model/device_finance/requests";
import { checkDfpState } from "../../utils/utils";



export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};


class Device extends  React.Component {
    formRef = React.createRef();
    constructor(props){
        super(props);
        this.state = {
            data:{},
            customId:"",
            isShow:true,
            raw:{}
        }
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    handlerSubmit = (e)=>{
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        getDeviceByImei({imei:imei}).then(res=>{
            if(res.data.code === 200){
                let data = res.data.data
                this.setState({
                    data:data,
                    isShow:false
                })

            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

        //  trigger the device to cloud 
        // getDeviceFinance({id:imei}).then(res=>{
        //     if(res.data.code === 200){
        //         let data = res.data.data
        //          this.setState({
        //             raw:data.raw_data
        //          })
        //     }else{
        //         message.error(res.data.msg)
        //     }
        //  }).catch(err=>{
        //      message.error(err)
        //  })
        
    }

    // refresh should add the column customId 
    handlerRefresh = (e) => {
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        // this part should add the forigen key cid to the custom tables;
        let cid = this.state.data.cid;
        if(cid <= 0 ){
            message.error("Missed Custom Foreign Key Cid")
            return false;
        }

        RefreshPing({imei:imei}).then(res=>{
            if(res.data.code === 200) {
                message.success("It's Online")
            }else{
                message.error("It's Offline")
            }
        }).catch(err=>{
            message.error("Offline")
        })
    }

    // Lock feature should add the column customId
    handlerLock = (e) => {
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        let cid = this.state.data.cid;
        if(cid <= 0 ){
            message.error("Missed Custom Foreign Key Cid")
            return false;
        }

        lock({imei:imei}).then(res=>{
            if(res.data.code === 200){
                message.success("lock it")
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    // UnLock should add the column customId
    handlerUnLock = (e) => {
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        let cid = this.state.data.cid;
        if(cid <= 0 ){
            message.error("Missed Custom Foreign Key Cid")
            return false;
        }
        unLock({imei:imei}).then(res=>{
            if(res.data.code === 200){
                message.success("unlock it")
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    // Reset should add the column customId
    // first should find the imei is exist then the custom_id is belongs to your group ,
    // then you can do operation
    handlerFactoryReset = (e) => {
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        let cid = this.state.data.cid;
        if(cid <= 0 ){
            message.error("Missed Custom Foreign Key Cid")
            return false;
        }
        factoryReset({imei:imei,cid:cid}).then(res=>{
            if(res.data.code === 200){
                message.success("Reset success")
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerEraseCID=(e)=>{
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        let cid = this.state.data.cid;
        if(cid <= 0 ){
            message.error("Missed Custom Foreign Key Cid")
            return false;
        }
        eraseCID({imei:imei}).then(res=>{
            if(res.data.code === 200){
                message.success("EraseCID success")
            }else{
                message.warn(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerEditDevice = (e) => {
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        this.props.history.push(route.search.edit_device+imei)
    }

    handlerStopFactoryReset = ()=>{
        let imei =  this.formRef.current.getFieldValue(dbFields.imei.key);
        let cid = this.state.data.cid;
        if(cid <= 0 ){
            message.error("Missed Custom Foreign Key Cid")
            return false;
        }

        stopFactoryReset({imei:imei,cid:cid}).then(res=>{
            if(res.data.code === 200){
                message.success(" Stop Reset success")
            }else{
                message.warn(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })

        
    }

    

    render(){
        let {data} = this.state;
        return (
            <>
             <BreadcrumbCustomer  first='Find Device' second='' />
                <Form
                //    {...layout}
                    ref={this.formRef}
                >
                    <Form.Item
                          name={dbFields.imei.key}
                          label={dbFields.imei.title}
                    >
                         <Input />
                    </Form.Item>

                    <Form.Item >
                            <Button 
                            type="primary"
                            style={{background: "#851dd6" }}
                            onClick={this.handlerSubmit}
                             >
                                Check
                            </Button>
                    </Form.Item>    
                </Form>
                <Divider />
                {Object.keys(data).length  ? (
                    <Descriptions bordered title="">

                     <Descriptions.Item label={dbFields.imei.title}>{data.imei}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.curef.title}>{data.curef}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.custom_id.title}>{data.custom_id}</Descriptions.Item>
                    <Descriptions.Item label={"Factory Reset"}>
                       {data.status === 1 ? "Factory Reset" : "Normal"}
                    </Descriptions.Item>
                    <Descriptions.Item label={"Device Status"}>
                       {data.is_lock === 0 ? "UNLOCK" : (data.is_lock === 1 ? "LOCK" : "PERMANENT UNLOCK" )}
                    </Descriptions.Item>
                    <Descriptions.Item label={"Last Online"}>{data.last_check_online}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.activation_date.title}>{data.activation_date}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.wifi_mac.title}>{data.wifi_mac}</Descriptions.Item> 
                </Descriptions> 
                ) : (<Empty />) }
            <Divider />
            <Space wrap>
                <Button 
                    disabled ={this.state.isShow}
                    style={{background: "#851dd6",color:"white" }}
                    onClick={this.handlerRefresh}
                >Refresh Now</Button>
                <Button
                  disabled ={this.state.isShow}
                  style={{background: "#851dd6",color:"white" }}
                  onClick={this.handlerLock}
                  type="primary"
                >
                    Lock</Button>
                <Button
                  disabled ={this.state.isShow}
                  style={{background: "#851dd6",color:"white" }}
                  onClick={this.handlerUnLock}
                  >UnLock</Button>
                <Button
                  disabled ={this.state.isShow}
   
                  onClick={this.handlerFactoryReset}
                  danger
                  type="primary"
                >Factory Reset</Button>
                <Button
                  disabled ={this.state.isShow}

                  onClick={this.handlerStopFactoryReset}
                  danger
                  type="primary"
                >Stop Reset</Button>
                 <Button
                  disabled ={this.state.isShow}

                  onClick={this.handlerEditDevice}
                  danger
                  type="primary"
                  >Switch C-ID
                </Button>
                <Button
                  disabled ={this.state.isShow}
              
                  onClick={this.handlerEraseCID}
                  danger
                  type="primary"
                  >Erase C-ID
                </Button>

            </Space>
                </>
        )
    }
}

export default Device;


